import React from "react";

const WhoCanEnroll = () => {
  const audienceList = [
    "Students",
    "NYSC Members",
    "Graduates",
    "IT Professionals",
    "Career Switchers",
  ];

  return (
    <section className="md:py-24 bg-white py-6 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-[#081B33] mb-5">
            Who Can Enrol?
          </h2>

          <div className="inline-flex px-6 py-3 rounded-full bg-[#12105E1A] border border-[#C8D7FF] mb-16">
            <span className="text-[#12105E] font-bold text-sm">
              No Prior Experience Required
            </span>
          </div>
        </div>

        {/* Cards */}
        <div className="flex flex-wrap justify-center gap-4">
          {audienceList.map((item, index) => (
            <div
              key={index}
              className="bg-white animate-bounce min-w-[120px] max-w-[220px] h-[58px] px-4 sm:px-6 rounded-2xl border border-gray-200 shadow-sm flex items-center justify-center"
            >
              <p className="text-[#0A1B33] font-medium text-sm text-center">
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoCanEnroll;
